import axios from "axios";
import {
    URLAPI,
    BANNER_IMAGE_PATH,
    BANNER_IMAGE_CREATE_PATH,
    BANNER_IMAGE_UPDATE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_banner_image: {
        data: [],
        status: 0,
        message: {},
    },
    _create_banner_image: {
        data: {},
        status: 0,
        message: {},
    },
    _update_banner_image: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_BANNER_IMAGE_SUCCESS = "GET_ALL_BANNER_IMAGE_SUCCESS";
export const CREATE_BANNER_IMAGE_SUCCESS = "CREATE_BANNER_IMAGE_SUCCESS";
export const UPDATE_BANNER_IMAGE_SUCCESS = "UPDATE_BANNER_IMAGE_SUCCESS";

export const banner_image_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_BANNER_IMAGE_SUCCESS:
            return {
                ...state,
                _get_all_banner_image: action.payload,
            };
        case CREATE_BANNER_IMAGE_SUCCESS:
            return {
                ...state,
                _create_banner_image: action.payload,
            };
        case UPDATE_BANNER_IMAGE_SUCCESS:
            return {
                ...state,
                _update_banner_image: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}

export const get_all_banner_image = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${BANNER_IMAGE_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_BANNER_IMAGE_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Ocurrió un error",
                },
            });
        }
    }
}

export const create_banner_image = (token, data) => async (dispatch) => {
    try {
        console.log(data);

        const response = await axios.post(`${URLAPI}${BANNER_IMAGE_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: CREATE_BANNER_IMAGE_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear",
                },
            });
        }
    }
}

export const update_banner_image = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${BANNER_IMAGE_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: UPDATE_BANNER_IMAGE_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_BANNER_IMAGE_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const clear_status_banner_image = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
